import { render, staticRenderFns } from "./technical-specification.vue?vue&type=template&id=90e67634"
import script from "./technical-specification.vue?vue&type=script&lang=js"
export * from "./technical-specification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports